import React, { useState } from 'react';
import { useAllLegalEntities } from '../../apis/shops-api';
import { GridColDef } from '@mui/x-data-grid';
import { LegalEntityDto } from '@kotipizzagroup/kotipizza-shops-api-admin-client';
import { DataGridContainer } from '../IngredientsPage';
import StyledDataGrid from '../../shared/DataGrid/StyledDataGrid';
import { useTranslation } from 'react-i18next';
import { TopBar } from '../ProductsPage';
import { Button, Typography } from '@mui/material';
import { useUserPermissions } from '../../apis/user-details';
import { checkPermissions, SHOPS_WRITE } from '../../shared/utils/permissions';
import LegalEntityModal from './components/LegalEntityModal';

const LegalEntitiesPage: React.FC = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState<LegalEntityDto | null>(null);

  const { data: legalEntities } = useAllLegalEntities();
  const { t } = useTranslation();
  const { roles: userPermissions } = useUserPermissions();

  const columns: GridColDef<LegalEntityDto>[] = [
    {
      field: 'legalEntityId',
      headerName: t('Id'),
      width: 100,
    },
    {
      field: 'legalEntityName',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'businessId',
      headerName: t('global.businessId'),
      flex: 1,
    },
    {
      field: 'vatId',
      headerName: t('global.vatId'),
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      align: 'right',
      flex: 1,
      renderCell: (params) => (
        <>
          <Button onClick={() => handleEdit(params.row)}>{t('global.edit')}</Button>
        </>
      ),
    },
  ];

  const rows = legalEntities || [];

  const handleModalOpen = () => {
    setSelected(null);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setSelected(null);
    setModalOpen(false);
  };

  const handleEdit = (data: LegalEntityDto) => {
    setSelected(data);
    setModalOpen(true);
  };

  return (
    <>
      <TopBar>
        <Typography variant="h1">{t('Companies')}</Typography>
        {checkPermissions(userPermissions || [], [SHOPS_WRITE]) && (
          <Button variant="contained" onClick={handleModalOpen} color="primary">
            {t('global.add')}
          </Button>
        )}
      </TopBar>
      <DataGridContainer>
        <StyledDataGrid
          columns={columns}
          rows={rows}
          getRowId={(r) => r.legalEntityId}
          initialState={{
            sorting: {
              sortModel: [{ field: 'date', sort: 'desc' }],
            },
          }}
        />
      </DataGridContainer>
      <LegalEntityModal isOpen={isModalOpen} item={selected} onClose={handleModalClose} />
    </>
  );
};

export default LegalEntitiesPage;
